import { Link } from 'react-router-dom';

import type { NotificationType } from '../api/client';
import { useLanguage } from '../lib/i18n/LanguageContext';
import { contactSupportUrl, notificationRoute } from '../lib/notificationRoutes';

/**
 * The two action buttons a notification row can carry (PO decision, v2): a
 * link to the page its type relates to, and a "Contact support" link —
 * shown together when a related page exists, and Contact support ALONE
 * when it doesn't. Shared between NotificationBell's dropdown items and the
 * full history page (Notifications.tsx) so the two never drift.
 */
export function NotificationActions({
  type,
  onNavigate,
}: {
  type: NotificationType;
  /** Called when the "go to page" link is clicked — e.g. to close the bell dropdown. */
  onNavigate?: () => void;
}) {
  const { dict } = useLanguage();
  const route = notificationRoute(type);
  const supportUrl = contactSupportUrl();

  if (!route && !supportUrl) return null;

  return (
    <div className="notification-actions">
      {route && (
        <Link to={route} className="notification-action-link" onClick={onNavigate}>
          {dict.notifications.actionGoToPage}
        </Link>
      )}
      {supportUrl && (
        <a href={supportUrl} className="notification-action-link notification-action-link--support">
          {dict.notifications.actionContactSupport}
        </a>
      )}
    </div>
  );
}
